import { createSimpleFunctional } from '@/util'

export const VCardActions = createSimpleFunctional('v-card-actions')
